import React from 'react';
import { INSPECTION } from '@/constants/testIds';

export default function InspectionModal({ open, form, setForm, onSubmit, onClose }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-6">
      <div className="bg-white rounded-sm max-w-2xl w-full max-h-[90vh] overflow-y-auto p-8">
        <h2 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Outfit' }}>New Inspection</h2>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-black mb-2">Inspection Type</label>
            <select
              data-testid={INSPECTION.typeSelect}
              value={form.inspection_type}
              onChange={(e) => setForm({ ...form, inspection_type: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
            >
              <option value="structural">Structural</option>
              <option value="electrical">Electrical</option>
              <option value="plumbing">Plumbing</option>
              <option value="roofing">Roofing</option>
              <option value="foundation">Foundation</option>
              <option value="hvac">HVAC</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-black mb-2">Findings</label>
            <textarea
              data-testid={INSPECTION.findingsInput}
              value={form.findings}
              onChange={(e) => setForm({ ...form, findings: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
              rows="4"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-black mb-2">Recommendations</label>
            <textarea
              data-testid={INSPECTION.recommendationsInput}
              value={form.recommendations}
              onChange={(e) => setForm({ ...form, recommendations: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
              rows="4"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-black mb-2">Severity</label>
            <select
              data-testid={INSPECTION.severitySelect}
              value={form.severity}
              onChange={(e) => setForm({ ...form, severity: e.target.value })}
              className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:ring-2 focus:ring-blue-600"
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="critical">Critical</option>
            </select>
          </div>
          <div className="flex gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-slate-300 rounded-sm hover:bg-slate-50 transition-all"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-3 bg-black text-white rounded-sm hover:bg-slate-800 transition-all"
            >
              Create Inspection
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
